<template>
	<router-link :to="{name:linkRouteName}" v-bind:id="'linkid-'+this.linkRouteName" class="circle-link" style="transform: translate(-50%, -50%);">
		<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 100 100" height="50px" width="50px">
			<circle cx="52" cy="52" r="25" stroke="white" stroke-width="6" fill="none"/>
		</svg>
	</router-link>

</template>

<script>

	import $ from "jquery"

	export default {
		name: "CircleLink",
		props: ['linkRouteName', 'linkPos'],
		mounted() {
			$(document).ready(this.updatePointer)
			$(window).resize(this.updatePointer)
			this.updatePointer()
		},
		methods: {
			updatePointer: function () {
				var image = {width: 1280, height: 720}
				var target = {x: this.linkPos[0], y: this.linkPos[1]}

				var pointer = $('#linkid-' + this.linkRouteName)

				var windowWidth = $(window).width()
				var windowHeight = $(window).height()

				// Get largest dimension increase
				var xScale = windowWidth / image.width
				var yScale = windowHeight / image.height
				var scale
				var yOffset = 0
				var xOffset = 0

				if (xScale > yScale) {
					// The image fits perfectly in x axis, stretched in y
					scale = xScale
					yOffset = (windowHeight - (image.height * scale)) / 2
				} else {
					// The image fits perfectly in y axis, stretched in x
					scale = yScale
					xOffset = (windowWidth - (image.width * scale)) / 2
				}
				pointer.css('top', (target.y) * scale + yOffset)
				pointer.css('left', (target.x) * scale + xOffset)
				// $('#linkid-' + this.linkRouteName).css({
				// 	'transform': 'translate(' + 3 + 'px,' + 5 + 'px)'
				// })
			}
		}


	}
</script>

<style scoped>
	.circle-link {
		position: fixed;
		/*top: 50%;*/
		/*left: 50%;*/
		color: white;
		opacity: .7;
		animation: blink 2s ease infinite;
	}

	@keyframes blink {

		50% {
			opacity: 0;
		}
		100% {
			opacity: .7;
		}
	}


</style>